import { atom } from "recoil";

/**
 * True when the print house has no available AI Credits.
 * Drives the red alert point on the AI Dashboard sidebar item.
 */
export const aiCreditsNavAlertState = atom<boolean>({
  key: "aiCreditsNavAlertState",
  default: false,
});
